'use client';

import { ToolsTranslations } from '@/lib/translations/types';

type Values = { operatingIncome: number; operatingCapital: number };

interface Props {
  values: Values;
  onValuesChange: (field: keyof Values, value: number) => void;
  translations: ToolsTranslations['rooc'];
}

export default function CalculatorInputs({ values, onValuesChange, translations }: Props) {
  const handleChange = (field: keyof Values) => (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value.replace(/\s/g, '').replace(/,/g, '');
    const value = Number(raw);
    onValuesChange(field, isNaN(value) ? 0 : value);
  };

  const inputClass = "w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500";

  return (
    <div className="space-y-6">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">{translations.operatingIncome}</label>
        <input type="text" value={values.operatingIncome.toLocaleString('sv-SE')} onChange={handleChange('operatingIncome')} className={inputClass} placeholder="0" />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">{translations.operatingCapital}</label>
        <input type="text" value={values.operatingCapital.toLocaleString('sv-SE')} onChange={handleChange('operatingCapital')} className={inputClass} placeholder="0" />
      </div>
    </div>
  );
}


